const slides = document.getElementById('slides');
const buttons = document.querySelectorAll('.timeline button');
let currentIndex = 0;
let startX = 0;

function goToSlide(index) {
    slides.style.transform = `translateX(-${index * 100}%)`;
    buttons.forEach(btn => btn.classList.remove('active'));
    buttons[index].classList.add('active');
    currentIndex = index;

    // Ensure active year scrolls into view
    buttons[index].scrollIntoView({ behavior: "smooth", inline: "center", block: "nearest" });
}

buttons.forEach(btn => {
    btn.addEventListener('click', () => {
        goToSlide(parseInt(btn.dataset.index));
    });
});

// Touch swipe
slides.addEventListener('touchstart', (e) => {
    startX = e.touches[0].clientX;
});

slides.addEventListener('touchend', (e) => {
    const endX = e.changedTouches[0].clientX;
    if (startX - endX > 50 && currentIndex < buttons.length - 1) {
        goToSlide(currentIndex + 1);
    } else if (endX - startX > 50 && currentIndex > 0) {
        goToSlide(currentIndex - 1);
    }
});